namespace AgerLMS.Logging {
    export interface SmsSendLogRow {
        Id?: number;
        RelatedEntityId?: number;
        RelatedEntityType?: number;
        UserId?: number;
        PhoneNumber?: string;
        SmsMessage?: string;
        SmsResponse?: string;
        SmsState?: number;
        SmsMessageId?: number;
        SendSmsType?: number;
        SenderUserId?: number;
        SendDate?: string;
        UserName?: string;
    }

    export namespace SmsSendLogRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PhoneNumber';
        export const localTextPrefix = 'Logging.SmsSendLog';
        export const deletePermission = 'Logging:SmsSendLog:Modify';
        export const insertPermission = 'Logging:SmsSendLog:Modify';
        export const readPermission = 'Logging:SmsSendLog:Read';
        export const updatePermission = 'Logging:SmsSendLog:Modify';

        export declare const enum Fields {
            Id = "Id",
            RelatedEntityId = "RelatedEntityId",
            RelatedEntityType = "RelatedEntityType",
            UserId = "UserId",
            PhoneNumber = "PhoneNumber",
            SmsMessage = "SmsMessage",
            SmsResponse = "SmsResponse",
            SmsState = "SmsState",
            SmsMessageId = "SmsMessageId",
            SendSmsType = "SendSmsType",
            SenderUserId = "SenderUserId",
            SendDate = "SendDate",
            UserName = "UserName"
        }
    }
}
